(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tur/start-subscription/assets/javascripts/views/payment-prompt.js') >= 0) return;  svs.modules.push('/components/tur/start-subscription/assets/javascripts/views/payment-prompt.js');
"use strict";

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }

(function (Backbone, _, svs) {
  'use strict';

  const formatTime = svs.utils.date.FormatTime;
  const capitalize = svs.utils.format.capitalize;
  svs.tur.start_subscription.views.PaymentPrompt = Marionette.View.extend({
    ui: {
      approveCheckbox: '#js-approve-checkbox',
      approveBtn: '.js-approve-ag',
      payWithAgBtn: '.js-pay-with-ag-button',
      payWithCardBtn: '.js-pay-with-card-button',
      registerBankaccountBtn: '.js-register-bankaccount',
      changeBankaccountBtn: '.js-change-bankaccount'
    },
    events: {
      'change @ui.approveCheckbox': 'toggleTermsApproved',
      'click @ui.approveBtn': 'approveBtnClicked',
      'click @ui.payWithAgBtn': 'payWithAgBtnClicked',
      'click @ui.payWithCardBtn': 'payWithCardBtnClicked',
      'click @ui.registerBankaccountBtn': 'registerBankaccountBtnClicked',
      'click @ui.changeBankaccountBtn': 'changeBankaccountBtnClicked'
    },
    regions: {
      paymentPromptRegion: '#paymentPromptRegion'
    },
    template() {
      return '<div id="paymentPromptRegion"></div>';
    },
    onRender() {
      this.showChildView('paymentPromptRegion', {
        _self: this,
        model: this.model,
        template(data) {
          return svs.tur.start_subscription.templates.payment_prompt(data);
        },
        templateContext() {
          if (!this.model.get('isBankcard') && !this.model.get('isAutogiro')) {
            this.model.set('isBankcard', true);
          }
          if (!this.model.get('entry')) {
            this.model.set('entry', this.model.get('cardEntry'));
            this.model.set('isBankcard', true);
          }
          const templateObject = {
            isBankcard: this.model.get('isBankcard'),
            hasActivePayChannel: this.model.get('hasActivePayChannel'),
            hasChangeablePayChannel: this.model.get('hasChangeablePayChannel'),
            amount: svs.utils.format.Currency(this.model.get('entry').amount),
            startTime: formatTime('d MMM', this.model.get('entry').startTime).replace('.', ''),
            stopTime: formatTime('d MMM', this.model.get('entry').stopTime).replace('.', ''),
            weeklyCost: svs.utils.format.Currency(this.model.get('subscriptionOptions').weeklyCost),
            dayCost: svs.utils.format.Currency(parseInt(this.model.get('subscriptionEntry').wagers[0].wagerAmount, 10)),
            gameDaysStart: parseInt(this.model.get('entry').amount, 10) / parseInt(this.model.get('subscriptionEntry').wagers[0].wagerAmount, 10),
            gameResultDate: capitalize(formatTime('EEEE d MMM', this.model.get('startTime')).replace('.', '')),
            lottoRuleChangePrice: svs.utils.format.Currency(this.model.get('subscriptionOptions').lottoRuleChangePrice),
            lottoRuleChangeDate: this.model.get('subscriptionOptions').lottoRuleChangeDate
          };
          return templateObject;
        },
        onBeforeAttach() {
          svs.utils.keylistener.addKeyboardListener(event => {
            if (event.keyCode === svs.utils.keylistener.KEY_ESC) {
            }
          });
          svs.components.Modal.setHeaderOptions({
            title: 'Betala prenumeration',
            contentClass: svs.core.detect.formfactor.mobile() ? 'bg-white' : '',
            doubleWidth: true,
            rightButton: {
              visible: false
            },
            leftButton: {
              text: 'Avbryt',
              visible: true,
              callback: () => {
                const options = this.options._self.options;
                const subscriptionId = options.model.get('newSubId');
                const cancelUrl = options.model.get('cancelUrl');
                const isHideLoader = !cancelUrl; 
                subscriptionId && svs.tur.start_subscription.radio.request('cancelSubscription', subscriptionId, this, () => {}, isHideLoader);

                const swpCheckout = svs.tur.start_subscription.radio.request('getSwedbankPayCheckoutObject', options.context);
                if (swpCheckout && swpCheckout.cleanUpSwedbankPayTransaction && typeof swpCheckout.cleanUpSwedbankPayTransaction === 'function') {
                  options.context.triggerPrefixMethod('cancelButtonFirstPayBankcardSubscription');
                  swpCheckout.cleanUpSwedbankPayTransaction();
                }

                svs.components.Modal.hide();
                if (cancelUrl) {
                  svs.components.loader.show();
                  svs.utils.url.navigate(cancelUrl);
                }
              }
            }
          });
          svs.components.Modal && svs.components.Modal.currentView() && svs.components.Modal.currentView().trigger('modalContentResize');
        },
        onAttach() {
          this.model.getAutogiroInfo();
          if (this.model.get('hasChangeablePayChannel')) {
            this.options.initDropdowns();
          }
          svs.components.Modal && svs.components.Modal.currentView() && svs.components.Modal.currentView().trigger('modalContentResize');
        },
        onRender() {
          svs.components.Modal && svs.components.Modal.currentView() && svs.components.Modal.currentView().trigger('modalContentResize');
        },
        initDropdowns() {
          const _self = this._self;
          const dropdownOptions = {
            el: 'js-dropdown-deposit',
            class: 'js-dropdown-deposit',
            clickCallback: function cb(item) {
              const clickedItem = item['data-item'];
              if (clickedItem === 'creditcard') {
                _self.model.set('isBankcard', true);
                _self.model.set('isAutogiro', false);
                _self.model.set('entry', _self.model.get('cardEntry'));
              } else {
                const swpCheckout = svs.tur.start_subscription.radio.request('getSwedbankPayCheckoutObject', _self.options.context);
                if (swpCheckout && swpCheckout.cleanUpSwedbankPayTransaction && typeof swpCheckout.cleanUpSwedbankPayTransaction === 'function') {
                  _self.options.context.triggerPrefixMethod('cancelDropdownFirstPayBankcardSubscription');
                  swpCheckout.cleanUpSwedbankPayTransaction();
                } else {
                  _self.options.context.triggerPrefixMethod('cancelDropdownBeforeFirstPayBankcardSubscription');
                }
                _self.model.set('isBankcard', false);
                _self.model.set('isAutogiro', true);
                _self.model.set('entry', _self.model.get('autogiroEntry'));
              }
              _self.render();
            }
          };
          new svs.ui.Dropdown(dropdownOptions);
        },
        initSwedbankPay() {
          const _self = this._self;
          const swpOptions = {
            context: _self
          };
          _self.swedbankPayCheckout = new svs.accountservices.swedbankpay_checkout.SwedbankPayCheckout(swpOptions);
        }
      });
    },
    autogiroClicked() {
      this.showConfirmPaymentMethod(this.model.get('autogiroEntry'), 'autogiro');
    },
    bankcardClicked() {
      this.showConfirmPaymentMethod(this.model.get('cardEntry'), 'kort');
    },
    showConfirmPaymentMethod(entry, paymentTypeText) {
      const _this$getDialogConfir = this.getDialogConfirmPaymentMessage(_objectSpread(_objectSpread({}, entry), {}, {
          paymentTypeText
        })),
        title = _this$getDialogConfir.title,
        message = _this$getDialogConfir.message;
      const dialog = new svs.ui.dialog.Confirm({
        branding: svs.ui.dialog.branding.TUR,
        icon: 'subscription',
        title,
        message,
        actions: [{
          title: 'Avbryt'
        }, {
          title: 'Starta',
          callback: () => {
            dialog.close(() => {
              this.model.set('entry', entry);
              svs.components.Modal.hide();
              this.options.context.triggerPrefixMethod('paymentTypeChosen');
            });
          }
        }]
      });
      svs.ui.dialog.api.add(dialog);
    },
    getDialogConfirmPaymentMessage(_ref) {
      let isAutogiro = _ref.isAutogiro,
        isBankcard = _ref.isBankcard,
        startTime = _ref.startTime,
        stopTime = _ref.stopTime,
        amount = _ref.amount,
        paymentTypeText = _ref.paymentTypeText;
      const weeklyCost = this.model.get('subscriptionOptions').weeklyCost;
      startTime = formatTime('d/M', startTime);
      stopTime = formatTime('d/M', stopTime);
      amount = svs.utils.format.Currency(amount);
      return {
        title: "Prenumeration med ".concat(paymentTypeText),
        message: [{
          type: svs.ui.dialog.message.TEXT,
          text: "Prenumerationen kostar ".concat(weeklyCost, " kr/vecka. <br/>") + "F\xF6r startperioden ".concat(startTime, " - ").concat(stopTime, " \xE4r totala kostnaden ").concat(amount, " kr") + "".concat(isBankcard ? ' och debiteras ditt bankkort direkt' : '', ".<br/>") + "".concat(isAutogiro ? "Detta belopp dras prelimin\xE4rt den ".concat(startTime, " f\xF6rutsatt att ditt autogiromedgivande blir godk\xE4nt.") : '')
        }]
      };
    },
    showChoosePayment() {
      this.showChildView('paymentPromptRegion', this.choosePaymentView);
    },
    showBankCardInfo() {
      this.changeView('Bankkort', svs.tur.start_subscription.templates.creditcard);
    },
    showAutogiroInfo() {
      this.changeView('Autogiro', svs.tur.start_subscription.templates.bankgiro);
    },
    changeView(title, template) {
      this.choosePaymentView = this.detachChildView('paymentPromptRegion');
      svs.components.Modal.setHeaderOptions({
        title,
        doubleWidth: true,
        leftButton: {
          visible: false
        },
        rightButton: {
          text: 'Tilbaka',
          visible: true,
          callback: function () {
            this.showChoosePayment();
          }.bind(this)
        }
      });
      this.showChildView('paymentPromptRegion', {
        template() {
          return template();
        }
      });
    },
    onDestroy() {
      this.choosePaymentView && this.choosePaymentView.destroy();
    },
    toggleTermsApproved() {
      $('.js-approve-ag').attr('disabled', !$('#js-approve-checkbox')[0].checked);
    },
    approveBtnClicked(e) {
      svs.tur.start_subscription.utils.preventDoubleClick(e.target);

      if (this.model.get('isPaymentTypeChanged')) {
        svs.tur.start_subscription.radio.request('changeSubscriptionPaymentType', this.model.get('paymentType'), this, () => this.options.context.createDirectDebitPermission());
      } else {
        this.options.context.createDirectDebitPermission();
      }
    },
    payWithAgBtnClicked(e) {
      svs.tur.start_subscription.utils.preventDoubleClick(e.target);

      if (this.model.get('isPaymentTypeChanged')) {
        svs.tur.start_subscription.radio.request('changeSubscriptionPaymentType', this.model.get('paymentType'), this, () => this.options.context.view.triggerMethod('autogiroPaymentAccessCreated'));
      } else {
        this.options.context.view.triggerMethod('autogiroPaymentAccessCreated');
      }
    },
    payWithCardBtnClicked(e) {
      svs.tur.start_subscription.utils.preventDoubleClick(e.target);
      this.options.context.triggerPrefixMethod('paymentTypeChosen');
    },
    registerBankaccountBtnClicked() {
      svs.utils.form.postToUrl(svs.core.urlMapping.get('transactionsWithdrawalRegisterBankAccount'), {
        returnUrl: window.location
      });
      return false;
    },
    changeBankaccountBtnClicked() {
      svs.utils.form.postToUrl(svs.core.urlMapping.get('transactionsWithdrawalChangeBankAccount'), {
        returnUrl: window.location
      });
      return false;
    }
  });
})(Backbone, _, svs);

 })(window);